let cache = new Map()

export default async function GjIconLoader(version, name) {
  let key = `${version}-${name}`

  if (cache.has(key)) {
    return cache.get(key)
  }

  // `https://s3.eu-central-2.wasabisys.com/codex-admin/gjirafa-icons/v${version}/${name}.svg`
  // `https://admin.codexcdn.net/gjirafa-icons/v0.2.3/ArrowReplyRight.svg`

  let iconHtml = fetch(
    `https://admin.codexcdn.net/gjirafa-icons/v${version}/${name}.svg`
  ).then((response) => {
    if (!response.ok) {
      throw new Error(response.statusText)
    }
    return response.text()
  })

  cache.set(key, iconHtml)

  return iconHtml
}
